import React from 'react';
import { useTabs, TabBar } from './TabManager';
import { useVbMenu, tabButtonOn } from '../utils/vbPerms';
import IncomeList from './Income/IncomeList';
import CityList from './Income/CityList';
import DepartmentList from './Income/DepartmentList';
import IncomeRefundList from './Income/IncomeRefundList';
import IncomeInoutList from './Income/IncomeInoutList';

const INCOME_BUTTONS = [
  { key: 'BTNEVAT', vb: 'BTNINCOMEINOUT',           label: 'وصول درآمد',                                icon: '💵', bg: 'linear-gradient(135deg,#1b5e20,#2e7d32)', page: 'evat' },
  { key: 'BTNREFUND', vb: 'BTNREFUNDINCOME',         label: 'رد وجوه اضافه دریافتی',                      icon: '↩️', bg: 'linear-gradient(135deg,#4a148c,#6a1b9a)', page: 'income_refund' },
  { key: 'BTNEVATDIST', vb: 'BTNEVAT',       label: 'وصول و توزیع مالیات بر ارزش افزوده',         icon: '📊', bg: 'linear-gradient(135deg,#e65100,#f57c00)', page: 'evat_dist' },
  { key: 'BTNEVATALLREPORT', vb: 'BTNINCOMEINOUTALLREPORTS',  label: 'گزارش کلی درآمدها',                          icon: '📋', bg: 'linear-gradient(135deg,#1a237e,#283593)', page: 'evat_report' },
  { key: 'BTNINCOME', vb: 'BTNINCOME2',         label: 'درآمدها',                                     icon: '💰', bg: 'linear-gradient(135deg,#006064,#00838f)', page: 'income_list' },
  { key: 'BTNCITIES', vb: 'BTNCITY2',         label: 'شهرها',                                       icon: '🏘️', bg: 'linear-gradient(135deg,#00838f,#006064)', page: 'cities' },
  { key: 'BTNAMOUNTREC', vb: 'BTNAMOUNTRECEIVERS2',      label: 'گیرندگان وجه',                                icon: '🤝', bg: 'linear-gradient(135deg,#880e4f,#ad1457)', page: 'amount_rec' },
  { key: 'BTNDEPARTMENTS', vb: 'BTNDEPARTMENTS3',    label: 'واحدهای اجرایی',                              icon: '🏢', bg: 'linear-gradient(135deg,#37474f,#455a64)', page: 'departments' },
];

const PAGE_COMPONENTS = {
  evat: IncomeInoutList,
  income_list: IncomeList,
  cities: CityList,
  departments: DepartmentList,
  income_refund: IncomeRefundList,
};

export default function Income({ user, onBack }) {
  const { openTab, closeTab, goHome } = useTabs();
  const openSubPage = (btn) => {
    const Comp = PAGE_COMPONENTS[btn.page];
    if (!Comp) { alert(`صفحه "${btn.label}" در حال توسعه است`); return; }
    openTab(`income:${btn.page}`, btn.label, btn.icon, () => <Comp user={user} onBack={goHome} />);
  };
  // دکمه‌های تب — دکمهٔ بی‌مجوز غیرفعال (خاکستری) دیده می‌شود
  const menu = useVbMenu();
  const allowedBtns = INCOME_BUTTONS.map(btn => ({
    ...btn, _on: tabButtonOn(menu, 'TBINCOME', btn.vb || btn.key),
  }));
  const enabledCount = allowedBtns.filter(b => b._on).length;
  const gridResponsiveCSS = `@media(max-width:640px){.arjan-acc-grid{grid-template-columns:repeat(2,1fr)!important;gap:16px!important;max-width:360px;margin:0 auto;padding:0 12px;}}`;
  return (
    <><style>{gridResponsiveCSS}</style>
    <div style={s.page}>
      <header style={s.header}>
        <div style={s.hLeft}>
          <button onClick={onBack} style={s.backBtn}>← بازگشت</button>
          <div style={s.hLogo}><img src={require('../assets/images/arjan.png')} alt="ارجان" style={{width:'36px',height:'36px',borderRadius:'8px'}}/></div>
          <div><div style={s.hTitle}>سامانه ارجان</div><div style={s.hSub}>بخش درآمد</div></div>
        </div>
        <span style={s.userName}>{user?.full_name}</span>
      </header>
      <TabBar/>
      <main style={s.main}>
        <div style={s.hero}><div style={s.heroIcon}>💵</div><div><h2 style={s.heroTitle}>بخش درآمد</h2><p style={s.heroSub}>{enabledCount} مورد در دسترس شما</p></div></div>
        {enabledCount > 0 || allowedBtns.length > 0 ? (
          <div className="arjan-acc-grid" style={s.grid}>
            {allowedBtns.map(btn => (
              <div key={btn.key} style={s.btnWrap}>
                <button disabled={!btn._on} style={{...s.btn,background:btn.bg,...(btn._on?{}:DISABLED)}} onClick={()=>btn._on&&openSubPage(btn)}
                  onMouseEnter={e=>{if(!btn._on)return;e.currentTarget.style.transform='translateY(-8px) scale(1.05)';e.currentTarget.style.boxShadow='0 16px 40px rgba(0,0,0,0.35)';}}
                  onMouseLeave={e=>{e.currentTarget.style.transform='translateY(0) scale(1)';e.currentTarget.style.boxShadow='0 8px 24px rgba(0,0,0,0.2)';}}>
                  <span style={s.btnIcon}>{btn.icon}</span>
                </button>
                <div style={s.btnLabel}>{btn.label}</div>
              </div>
            ))}
          </div>
        ) : (<div style={s.noAccess}><div style={{fontSize:'56px',marginBottom:'16px'}}>🔒</div><div style={{fontSize:'16px',color:'#666'}}>دسترسی به این بخش تعریف نشده است</div></div>)}
      </main>
    </div></>
  );
}

/* استایل‌ها */
const s = {
  page:{minHeight:'100vh',background:'#f0f2f7',fontFamily:"'Vazirmatn',Tahoma,sans-serif",direction:'rtl'},
  header:{background:'linear-gradient(135deg,#0a1628,#1a2f50)',padding:'12px 24px',display:'flex',justifyContent:'space-between',alignItems:'center',boxShadow:'0 2px 16px rgba(0,0,0,0.3)',position:'sticky',top:0,zIndex:100},
  hLeft:{display:'flex',alignItems:'center',gap:'12px'},
  backBtn:{padding:'6px 14px',background:'rgba(255,255,255,0.12)',color:'#fff',border:'1px solid rgba(255,255,255,0.25)',borderRadius:'7px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px'},
  hLogo:{width:'40px',height:'40px',background:'rgba(200,168,75,0.12)',border:'1px solid rgba(200,168,75,0.3)',borderRadius:'9px',display:'flex',alignItems:'center',justifyContent:'center'},
  hTitle:{fontSize:'16px',fontWeight:'700',color:'#fff'},
  hSub:{fontSize:'11px',color:'rgba(255,255,255,0.55)'},
  userName:{fontSize:'13px',color:'rgba(255,255,255,0.85)'},
  main:{padding:'32px 24px',maxWidth:'1100px',margin:'0 auto'},
  hero:{display:'flex',alignItems:'center',gap:'16px',marginBottom:'32px'},
  heroIcon:{fontSize:'40px'},
  heroTitle:{fontSize:'22px',fontWeight:'800',color:'#1a2f50',margin:0},
  heroSub:{fontSize:'13px',color:'#888',margin:'4px 0 0'},
  grid:{display:'grid',gridTemplateColumns:'repeat(4,160px)',gap:'24px',justifyContent:'center'},
  btnWrap:{display:'flex',flexDirection:'column',alignItems:'center',gap:'10px'},
  btn:{width:'100%',aspectRatio:'1',border:'none',borderRadius:'20px',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',boxShadow:'0 8px 24px rgba(0,0,0,0.2)',transition:'all .25s'},
  btnIcon:{fontSize:'36px'},
  btnLabel:{fontSize:'13px',fontWeight:'700',color:'#333',textAlign:'center'},
  noAccess:{textAlign:'center',padding:'60px 20px'},
};

// دکمهٔ تبِ بی‌مجوز: دیده می‌شود ولی کار نمی‌کند
const DISABLED = { filter: 'grayscale(1)', opacity: 0.45, cursor: 'not-allowed', boxShadow: 'none' };
